/** @format */
import { Component, ContentChildren, Input, TemplateRef, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'sis-description-list-compact',
    templateUrl: './description-list-compact.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class DescriptionListCompactComponent {
    @Input() fillByColumn = true;
    @Input() columnCount = 2;
    /** Id(s) of the element(s) that describe the list, passed to the `aria-describedby` attribute of the list element. */
    @Input() ariaDescribedBy?: string;

    @ContentChildren('compactListItem', { read: TemplateRef, descendants: true }) childTemplates: TemplateRef<any>[];
}
